import styled from '@emotion/styled'

import { CTAButtonWithWT } from '@f-fertighaus/applications/Next/components/common/CTAButton'

import { t } from '../../public/locales/de'
import { useHouseDetail } from '../../utils/context/HouseDetail'

const StickyContainer = styled.div`
  position: sticky;
  width: 100%;
  bottom: 0;
  text-align: center;
  padding: ${({ theme }) => theme.spacing(2, 0, 1)};
  background-color: ${({ theme }) => theme.palette.common.white};
  z-index: 102;
  box-shadow: ${({ theme }) =>
    `0px -4px 18px -15px ${theme.palette.primary.main}`};
  label: FixedContainer;
  display: block;
  ${({ theme }) => theme.breakpoints.up('md')} {
    display: none;
  }
`

export const StickyCTA = () => {
  const { state } = useHouseDetail()

  const isDisabled = !state.active

  return (
    <StickyContainer>
      <CTAButtonWithWT
        disabled={isDisabled}
        wtPayload={{
          category: 'CTA-button',
          action: 'click',
          label: 'primary-CTA',
          indicates: ['funnel-entry'],
          location: 'sticky-bottom',
          values: [{ type: 'text', value: 'Preisdetails kostenlos anfordern' }]
        }}
        variant='contained'
        color='secondary'
        data-request-type='house-detail-form'
        data-funnel-variant='house-wizard-item-priceinfo'
        data-sel='btn-cta-hdp-sticky'
        {...(state.vendor_nid && { 'data-vendor-nid': state.vendor_nid })}
        className='js-request-button'>
        {t('houseDetailPage.fixedCTA')}
      </CTAButtonWithWT>
    </StickyContainer>
  )
}
